import _ from 'lodash';
import { Auth } from '../../../config/configuration/react';

const getSumAds = (marketInformation) =>
  _.sum([
    _.get(marketInformation, 'nbrAdsOfParticular', 0),
    _.get(marketInformation, 'nbrAdsOfNetwork', 0),
    _.get(marketInformation, 'nbrAdsOfOtherPro', 0),
  ]);

export const versionsPresenter = (versions) => {
  if (versions) {
    return Object.values(versions).map((version) =>
      _.set(version.marketInformation, 'totalAds', getSumAds(version.marketInformation)),
    );
  }
  return null;
};

export const versionsListPresenter = (versions, record) => {
  const originId = _.get(record, 'originId', null);
  const countryId = _.get(record, 'countryId', null);
  let versionList = [...versions];
  if (Auth.country() !== 'NL') {
    if (originId < 10 && countryId === 7) {
      const coteOptionRef = _.filter(versionList, (opt) => opt.ref === true);
      const coteOptionMcclbp = _.filter(versionList, (opt) => opt.ref === false && opt.mcclbp === true);
      versionList = _.filter(versionList, (opt) => opt.ref === false && opt.mcclbp === false);
      if (coteOptionRef.length > 0 && coteOptionMcclbp.length > 0)
        coteOptionRef.unshift({ id: -1, name: 'separatorRef' });
      if (
        (coteOptionMcclbp.length > 0 && versionList.length > 0) ||
        (coteOptionRef.length > 0 && versionList.length > 0)
      )
        coteOptionMcclbp.unshift({ id: -2, name: 'separatorMcclbp' });
      coteOptionMcclbp.forEach((version) => {
        versionList.unshift(version);
      });
      coteOptionRef.forEach((version) => {
        versionList.unshift(version);
      });
    } else {
      const coteOption = _.filter(versionList, (opt) => opt.ref === true);
      versionList = _.filter(versionList, (opt) => opt.ref === false);
      if (coteOption.length > 0 && versionList.length > 0) coteOption.unshift({ id: -1, name: 'separator' });
      coteOption.forEach((version) => {
        versionList.unshift(version);
      });
    }
  }
  return versionList;
};
